
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteC as ObiOwnShipRemoteCElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-c.js';
 
 
 

 
 export const ObiOwnShipRemoteC = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-c',
   elementClass: ObiOwnShipRemoteCElement,
   events: {
     
   }
  });
 
 